// extracted by mini-css-extract-plugin
export default {"section":"Iv-z","inSectionButton":"Jv-z","addressCard":"Kv-z","disabled":"Lv-z","cautionBox":"Mv-z","failureBox":"Nv-z","fade-out":"Ov-z","successBox":"Pv-z"};